import React from 'react';
import { isEmpty } from 'ramda';

// store
import { useStoreValue } from '../../../../../../store';

// components
import SoundBetweenLogo from '../../../../../../assets/images/SoundBetween.png';

const StudioLogo = () => {
    const myStudioLeftPanel = useStoreValue('myStudioLeftPanel');

    return (
        isEmpty(myStudioLeftPanel) ? <div className="timelineEditorAuxControls__logo">
            <picture>
                <img src={SoundBetweenLogo} alt="soundbetween"/>
            </picture>
        </div> : null
    );
};

export default StudioLogo;
